<template>
  <div class="container-fluid m-0 p-0">
    <div class="row bg-light text-left border-top border-bottom py-2 ml-1">
      <div class="col-sm-12 h-100 my-auto p-0 m-0">
        <span class="mx-3 font-weight-bold lead">Per Document Monitoring</span>
        <span class="mx-3">
<!--          <button class="btn btn-sm btn-outline-primary font-weight-bolder"-->
          <!--                  data-toggle="modal"-->
          <!--                  data-target="#add-document"-->
          <!--          >-->
          <!--            <span class="fas fa-plus"></span>-->
          <!--            Add Document-->
          <!--          </button>-->
        </span>
        <span class="float-right py-1 mx-2 pr-4">
          <button class="btn btn-xs btn-outline-secondary px-2 mr-1" title="Go to Previous Page"
                  @click="goBack"
          >
            <span class="fas fa-backward"></span>
            Go Back
          </button>
        </span>
      </div>
    </div>

    <div class="row text-small pt-3">
      <div class="col col-md-12" style="min-height: 450px !important;">
        <div class="form-group form-inline mb-0">
          <div class="col-md-4 input-group form-inline justify-content-end mt-2">
            <label for="date-from" class="form-control-xs font-weight-bold mr-1">
              Search Document Date Expiry:
            </label>
          </div>

          <div class="col-md-4 input-group form-inline ">
            <label for="dateFrom" class="form-control-xs font-weight-bold mr-1">
              From:
            </label>
            <input type="date"
                   id="date-from"
                   class="form-control form-control-xs"
                   v-model="params.documentExpiryDateFrom"
                   @input="setPage(0)">

            <label for="dateTo" class="form-control-xs font-weight-bold ml-3 mr-1">
              To:
            </label>
            <input type="date" id="date-to"
                   class="form-control form-control-xs"
                   v-model="params.documentExpiryDateTo"
                   @input="setPage(0)"
            >
          </div>
          <div class="col-md-4 input-group form-inline mt-2">

          </div>
        </div>
        <div class="form-group form-inline">
          <!--          <label for="search-document" class="pr-3 font-weight-bold">Search Document Here: </label>-->
          <!--          <input class="form-control form-control-sm mr-2 w-20" id="search-document" style=""-->
          <!--                 type="search" placeholder="Input Any Here . . ."-->
          <!--                 v-model="params.searchValue"-->
          <!--                 @input="debouncedSearch"-->
          <!--          >-->
          <div class="form-group">
          <label for="document" class="pr-3 font-weight-bold ml-3 mt-3">Document: </label>
          <select id="document"
                  class="form-control form-control-xs input-group-append mt-3"
                  v-model="params.documentIds"
                  @change="handleDocumentChange">
            <option :value="[96, 52, 200, 24, 8, 18]">ALL DOCUMENTS</option>
            <option v-for="document in JISSdocuments"
                    :key="document.id"
                    :title="document.name"
                    :value="document.id">
              {{ document.name }}
            </option>
          </select>
          </div>
          <div class="form-group">
          <label v-if="this.isPrincipal && manningKeys.length > 1"
                 for="manning" class="pr-3 font-weight-bold ml-3 mt-3">
            Manning:
          </label>
          <select id="manning"
                  v-if="this.isPrincipal && manningKeys.length > 1"
                  class="form-control form-control-xs input-group-append mt-3"
                  v-model="params.manningId"
                  @change="handleVesselChange">
            <option :value="null">ALL MANNING</option>
            <option v-for="manningKey in manningKeys"
                    :key="manningKey.id"
                    :title="manningKey.name"
                    :value="manningKey.id">
              {{ manningKey.alias }}
            </option>
          </select>
          </div>
          <div class="form-group">
          <label for="vessel" class="pr-3 font-weight-bold ml-3 mt-3">Vessel: </label>
          <select id="vessel"
                  class="form-control form-control-xs input-group-append mt-3"
                  v-model="params.vesselId"
                  @change="setPage(0)">
            <option :value="null">ALL VESSEL</option>
            <option v-for="vessel in vesselKeys" :key="vessel.id" :value="vessel.id">
              {{ vessel.name }}
            </option>
          </select>
          </div>

          <label for="nationality" class="pr-3 font-weight-bold ml-3 mt-3">Nationality: </label>
          <select id="nationality"
                  class="form-control form-control-xs input-group-append  mt-3"
                  v-model="params.nationalityId"
                  @change="setPage(0)">
            <option :value="null">ALL NATIONALITY</option>
            <option v-for="natlKey in natlKeys"
                    :key="natlKey.id"
                    :value="natlKey.id"
                    :title="natlKey.natl"
            >{{ natlKey.natl }}
            </option>
          </select>
          <div class="form-group">
          <label for="rank" class="pr-3 font-weight-bold ml-3 mt-3">Rank: </label>
          <select id="rank"
                  class="form-control form-control-xs input-group-append mt-3"
                  v-model="params.rankId"
                  @change="setPage(0)"
          >
            <option :value="null">ALL RANKS</option>
            <option  value="do">DECK OFFICERS</option>
            <option  value="drcdt">DECK RATINGS & CDT</option>
            <option  value="eo">ENGINE OFFICERS</option>
            <option  value="ercdt">ENGINE RATINGS & CDT</option>
            <option  value="stwrd ">STEWARD </option>
            <option v-for="rankKey in rankObjKeys"
                    :key="rankKey.id"
                    :title="rankKey.name"
                    :value="rankKey.id"
            >{{ rankKey.alias }}
            </option>
          </select>
          </div>
          <div class="form-group">
          <label for="activityCode" class="pr-3 font-weight-bold ml-3 mt-3">Activity Status: </label>
          <select id="activityCode" class="form-control form-control-xs input-group-append mt-3"
                  v-model="params.activityCode"
                  @change="setPage(0)"
          >
            <option :value="null">ALL ACTIVITY STATUSES</option>
            <option v-for="activityCodeKey in activityCodeKeys"
                    :key="activityCodeKey.id"
                    :value="activityCodeKey.id"
                    :title="activityCodeKey.name">{{ activityCodeKey.name }}
            </option>
          </select>
          </div>
          <div class="form-group">
          <label for="status" class="pr-3 font-weight-bold ml-3 mt-3">Account Status: </label>
          <select id="status" class="form-control form-control-xs input-group-append mt-3"
                  v-model="params.crewStatus"
                  @change="setPage(0)"
          >
            <option :value="null">ALL ACCOUNT STATUSES</option>
            <option :value="1">ACTIVE</option>
            <option :value="0">INACTIVE</option>
          </select>
          </div>
          <div class="form-group">
          <label  v-show="params.documentIds === 18" for="isWatchKeepingStamp" class="pr-3 font-weight-bold ml-3 mt-3">With
            Watch keeping Stamp: </label>
          <select id="isWatchKeepingStamp" class="form-control form-control-xs input-group-append mt-3"
                  v-show="params.documentIds === 18"
                  v-model="params.isWatchKeepingStamp"
                  @change="setPage(0)"
          >
            <option :value="null">ALL WATCH KEEPING STAMP</option>
            <option :value="1">YES</option>
            <option :value="0">NO</option>
          </select>
        </div>
        </div>
        <div class="form-group form-inline">

          <div class="ml-auto">
<!--            <span  class="font-weight-bold mr-3">Counts Per Page:</span>-->
<!--            <select id="counts"-->
<!--                    class="form-control form-control-xs input-group-append mr-3"-->
<!--                    v-model="params.counts"-->
<!--                    @change="setPage(0)"-->
<!--                    style="width: 150px;">-->
<!--              <option id="nationalityOption0" :value="null" disabled selected>-&#45;&#45;Select -&#45;&#45;</option>-->
<!--              <option value="">10</option>-->
<!--              <option v-for="option in perPageOptions" :key="option.value" :value="option.value">-->
<!--                {{ option.label }}-->
<!--              </option>-->
<!--            </select>-->
            <button v-if="!isLoading" id="generateReportPDF"
                    :disabled="Object.values(params).every(value => value === null)"
                    class="btn btn-danger btn-xs p-1 mr-1"
                    @click="generateDocumentMonitoringPDF">
              <i class="fas fa-file-pdf fa-2x mx-1"></i>
              Generate as PDF
            </button>
            <button v-if="!loadingPdf" id="generateReportPDF"
                    :disabled="Object.values(params).every(value => value === null)"
                    class="btn btn-success btn-xs p-1"
                    @click="generateDocumentMonitoringExcel">
              <i class="fas fa-file-excel fa-2x mx-1"></i>
              Generate as Excel
            </button>
          </div>
        </div>

        <div v-if="isLoading">
          <app-loading></app-loading>
        </div>
        <div class="table-responsive text-small"  v-else>
          <table class="table table-hover table-bordered table-template-1 text-small sticky-header text-nowrap">
            <thead>
            <tr>
              <th>#</th>
              <th class="">RANK</th>
              <th @click="sortTable('crewName')" @mouseover="isHoverColumnCrewName = true"
                  @mouseleave="isHoverColumnCrewName = false"
                  :class="{ 'hovered': isHoverColumnCrewName, 'active-sort': params.sortColumn === 'crewName' }">CREW NAME
                <i v-if="params.sortColumn === 'crewName'"
                   :class="params.sortOrder === 'asc' ? 'fas fa-arrow-up' : 'fas fa-arrow-down'"></i>
              </th>

              <th>ACTIVITY</th>
              <th >DOCUMENT NAME</th>
              <th>DOCUMENT NO.</th>
              <th>ISSUE DATE</th>
              <th @click="sortTable('documentExpiryDate')"
                  @mouseover="isHoverColumnDocumentDateExpiry = true" @mouseleave="isHoverColumnDocumentDateExpiry = false"
                  :class="{ 'hovered': isHoverColumnDocumentDateExpiry, 'active-sort': params.sortColumn === 'documentExpiryDate' }"
              >
                EXPIRY DATE
                <i v-if="params.sortColumn === 'documentExpiryDate'"
                   :class="params.sortOrder === 'asc' ? 'fas fa-arrow-up' : 'fas fa-arrow-down'"></i>
              </th>
              <th>MANNING</th>
              <th>VESSEL/ EV-VSL</th>
              <th >NATIONALITY</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(crewDocument, index) in documentMonitoring.data" :key="crewDocument.id">
              <td>{{ index + pagination.from }}</td>
              <td>{{ crewDocument.crewInfo.crewRankInfo.rankAlias }}</td>
              <td>
                <router-link :to="{name:'CrewActivity',params:{id:crewDocument.crewInfo.crewId}}"
                             target="_blank"
                             v-if="crewDocument.crewInfo.crewName"
                             class="mb-0">{{ crewDocument.crewInfo.crewName }}
                </router-link>
              </td>
              <td>{{ crewDocument.crewInfo.activityCodeName }}</td>
              <td >{{ crewDocument.documentInfo.documentName }}</td>
              <td>{{ crewDocument.documentInfo.docNo }}</td>
              <td>{{ crewDocument.documentInfo.dateIssued }}</td>
              <td :class="{
                      'bg-danger text-white':crewDocument.documentInfo.warningColor.warningColor==='RED',
                      'bg-warning text-white':crewDocument.documentInfo.warningColor.warningColor==='YELLOW',
                    }">{{ crewDocument.documentInfo.expiryDate }}
              </td>
              <td>{{ crewDocument.manningInfo.manningName }}</td>
              <td >{{ crewDocument.vesselInfo.vesselName }}</td>
              <td>{{ crewDocument.manningInfo.manningNationality }}</td>
            </tr>
            </tbody>
          </table>
        </div>


      </div>

      <nav aria-label="..." class="ml-3 pt-2">
        <ul class="pagination text-smallest">
          <li class="page-item" :class="{ 'disabled': pagination.currentPage === 1}">
            <button class="page-link" @click="setPage(1)">First</button>
          </li>

          <li v-for="page in paginationPages" :key="page" class="page-item"
              :class="{ 'disabled': page === '...', 'active': page === pagination.currentPage }">
            <button class="page-link" @click="setPage(page)">{{ page }}</button>
          </li>

          <li class="page-item" :class="{ 'disabled': pagination.currentPage === pagination.lastPage}">
            <button class="page-link" @click="setPage(pagination.lastPage)">Last</button>
          </li>
        </ul>
      </nav>

    </div>

  </div>
</template>

<script>

import AppModal from "@/components/elements/AppModal";

import {mapGetters, mapActions} from 'vuex';
import {vueAppMixin} from "@/mixins/vueAppMixin";
import {gateMixin} from "@/mixins/gateMixin";
import {paginationMixin} from "@/mixins/paginationMixin";
import appLoading from "@/components/elements/AppLoading.vue";
import {ReportService} from "@/services/ReportService";
import DownloadPDFLoading from '../../../elements/DownloadPDFLoading';
import DownloadExcelLoading from '../../../elements/DownloadExcelLoading';
import {debounce} from "lodash";

export default {
  name: "GeneratePerDocumentMonitoring",

  mixins: [vueAppMixin, paginationMixin, gateMixin],

  components: {appLoading,},
  data() {
    return {
      JISSdocuments: [
        {id: 96, name: "HEALTH & GALLEY MANAGEMENT COURSE"},
        {id: 52, name: "JAPANESE COOK TRAINING CERTIFICATE"},
        {id: 200, name: "JAPANESE SHIP’S COOK LICENSE"},
        {id: 24, name: "JAPANESE COOK LICENSE"},
        {id: 8, name: "COP_MEDICAL_CARE"},
        {id: 18, name: "JAPANESE SEAMAN BOOK"}

      ],
      perPageOptions: [
        // { label: '10', value: 10 },
        {label: '20', value: 20},
        {label: '30', value: 30},
        {label: '40', value: 40},
        {label: '50', value: 50},
        {label: '60', value: 60},
        {label: '70', value: 70},
        {label: '80', value: 80},
        {label: '90', value: 90},
        {label: '100', value: 100},
      ],
      params: {
        counts: null,
        searchValue: null,
        documentIds: [96, 52, 200, 24, 8, 18],
        documentTypeId: null,
        documentStatus: null,
        isWatchKeepingStamp: null,
        rankId: null,
        manningId: null,
        vesselId: null,
        nationalityId: null,
        documentExpiryDateFrom: null,
        documentExpiryDateTo: null,
        activityCode: null,
        crewStatus: null,
        sortOrder: null,
        sortColumn: null,
      },
      loadingPdf:false,
      isHoverColumnCrewName: false,
      isHoverColumnDocumentDateExpiry: false
    }
  },

  methods: {
    ...mapActions([
      'getDocumentMonitoring',
      'getActivityCodeKeys',
      'getDocumentTypeKeys',
      'getNatlKeys',
      'getManningKeys',
      'getVesselKeys',
      'getRankObjKeys',
      'addDocument',
    ]),


    async generateDocumentMonitoringPDF() {
      if (this.params.documentIds === null) {
        this.params.documentIds = this.JISSdocuments.map(document => document.id);
      }
      this.params.counts = this.params.counts || null;
      this.params.isWatchKeepingStamp = this.params.isWatchKeepingStamp || null;
      this.params.manningId = this.params.manningId || null;
      this.params.vesselId = this.params.vesselId || null;
      this.params.rankId = this.params.rankId || null;
      this.params.documentExpiryDateFrom = this.params.documentExpiryDateFrom || null;
      this.params.documentExpiryDateTo = this.params.documentExpiryDateTo || "";
      this.params.activityCode = this.params.activityCode || null;
      this.params.crewStatus = this.params.crewStatus !== undefined ? this.params.crewStatus : null;
      this.params.nationalityId = this.params.nationalityId || null;
      this.params.searchValue = this.params.searchValue || null;
      this.params.sortColumn = this.params.sortColumn || null;
      this.params.sortOrder = this.params.sortOrder || null;
      await ReportService.generateJISSPERDocumentMonitoringPDF(this.params);
    },

    async generateDocumentMonitoringExcel() {
      if (this.params.documentIds === null) {
        this.params.documentIds = this.JISSdocuments.map(document => document.id);
      }
      this.params.counts = this.params.counts || null;
      this.params.isWatchKeepingStamp = this.params.isWatchKeepingStamp || null;
      this.params.manningId = this.params.manningId || null;
      this.params.vesselId = this.params.vesselId || null;
      this.params.rankId = this.params.rankId || null;
      this.params.documentExpiryDateFrom = this.params.documentExpiryDateFrom || null;
      this.params.documentExpiryDateTo = this.params.documentExpiryDateTo || "";
      this.params.activityCode = this.params.activityCode || null;
      this.params.crewStatus = this.params.crewStatus !== undefined ? this.params.crewStatus : null;
      this.params.nationalityId = this.params.nationalityId || null;
      this.params.searchValue = this.params.searchValue || null;
      this.params.sortColumn = this.params.sortColumn || null;
      this.params.sortOrder = this.params.sortOrder || null;
      await ReportService.generateJISSPERDocumentMonitoringExcel(this.params);
    },
    async initializeData() {
      this.getDocumentMonitoring({documentIds: this.JISSdocuments.map(document => document.id)});
      this.getDocumentTypeKeys();
      this.getRankObjKeys();
      this.getVesselKeys();
      this.getManningKeys();
      this.getNatlKeys();
      this.getActivityCodeKeys();
    },

    updateVesselKeys() {
      if (this.isOchg || !this.isSystemAdmin || this.isKobe) {
        let previousVesselId = this.params.vesselId;
        this.params.vesselId = null;
        let vesselParams = {
          manningId: this.params.manningId
        };
        this.getVesselKeys(vesselParams);

        if (previousVesselId !== null) {
          this.params.vesselId = previousVesselId;
        }
      }

    },
    handleDocumentChange(event) {
      for (const key in this.params) {
        if (key !== 'documentIds') {
          this.params[key] = null;
        }
      }
      this.setPage(0);
    },

    handleVesselChange(event) {
      this.params.vesselId = null;
      this.setPage(0);
    },

    updateRankKeys() {
      let previousRankId = this.params.documentIds;
      let previousWatchKeepingStamp = this.params.isWatchKeepingStamp;

      let documentParams = {
        documentId: this.params.documentIds,
        isWatchKeepingStamp: this.params.isWatchKeepingStamp
      };

      this.getRankObjKeys(documentParams);

      if (previousRankId !== null || previousWatchKeepingStamp !== null) {
        this.params.documentIds = previousRankId;
        this.params.isWatchKeepingStamp = previousWatchKeepingStamp;
      }
    },


    debouncedSearch: debounce(function () {
      this.searchDocumentMonitoring();
    }, 500),


    sortTable(column) {
      if (this.params.sortColumn === column) {
        if (this.params.sortOrder === 'asc') {
          this.params.sortOrder = 'desc';
        } else if (this.params.sortOrder === 'desc') {
          this.params.sortOrder = null;
          this.params.sortColumn = null;
        } else {
          this.params.sortOrder = 'asc';
        }
      } else {
        this.params.sortColumn = column;
        this.params.sortOrder = 'asc';
      }
      this.searchDocumentMonitoring();
      this.setPage(0);
    },
    searchDocumentMonitoring() {
      let page = this.pagination.currentPage;
      if (this.params.documentIds === null) {
        this.params.documentIds = this.JISSdocuments.map(document => document.id);
      }
      let params = {
        page: page,
        counts: this.params.counts,
        searchDocumentName: this.params.searchValue,
        documentIds: this.params.documentIds,
        isWatchKeepingStamp: this.params.isWatchKeepingStamp,
        activityCode: this.params.activityCode,
        crewStatus: this.params.crewStatus,
        documentTypeId: this.params.documentTypeId,
        rankId: this.params.rankId,
        manningId: this.params.manningId,
        vesselId: this.params.vesselId,
        manningNationalityId: this.params.nationalityId,
        documentExpiryDateFrom: this.params.documentExpiryDateFrom,
        documentExpiryDateTo: this.params.documentExpiryDateTo,
        sortColumn: this.params.sortColumn,
        sortOrder: this.params.sortOrder,
      };
      if (this.params.documentIds !== null) {
        this.updateRankKeys();
      }
      if (this.params.isWatchKeepingStamp === 1) {
        this.updateRankKeys();
      }
      if (this.params.manningId !== null) {
        this.updateVesselKeys();
      }
      if (params.documentIds !== 18) {
        params.isWatchKeepingStamp = null;
      }
      this.getDocumentMonitoring(params);


    },


    setPage(page) {
      this.pagination.currentPage = page;
      this.searchDocumentMonitoring();
    },


  },

  computed: {
    ...mapGetters([
      'rankObjKeys',
      'natlKeys',
      'vesselKeys',
      'manningKeys',
      'documentMonitoring',
      'activityCodeKeys'
    ]),
  },

  created() {
    this.initializeData();
    if (this.user.manning_id) {
      this.manning = this.user.manning_id;
    } else {
      // this.manning = this.manningId;
      this.manning = 0;
    }
  },

};
</script>

<style scoped>
/*th {*/
/*  background: lightgray;*/
/*  position: sticky;*/
/*  top: 0;*/
/*}*/

table.table-fit {
  width: auto !important;
  table-layout: auto !important;
}
table.table-fit thead th,
table.table-fit tbody td,
table.table-fit tfoot th,
table.table-fit tfoot td {
  width: auto !important;
}
.hovered {
  background-color: #b9f6ff;
}
</style>